import { Routes } from '@angular/router';

import { homeRoutes } from './home/home.routes';
import { transportationRoutes } from './transportation/transportation.routes';
import { lpgDistRoutes } from './lpg-dist';
import { securityRoutes } from './security/security-routing.module';
import { marketRoutes } from './market/market.routes';
import { handlerRoutes } from './shared/handler-error/handler-error.routes';
import { organisationRouts } from './organisation/organisation.routes';

export const routes: Routes = [
  ...homeRoutes,
  ...transportationRoutes,
  ...lpgDistRoutes,
  ...securityRoutes,
  ...marketRoutes,
  ...handlerRoutes,
  ...organisationRouts
];
